<template>
    <div class="markets-header">
        <app-header-mini v-if="this.$route.params.category === 'rolled-foils'" :img="'/static/img/products/rolled/rolled_header.jpg'" :texts="textsRolledOne"></app-header-mini>
        <app-header-mini v-if="this.$route.params.category === 'rolled-sheets-and-strips'" :img="'/static/img/products/rolled/rolled_header.jpg'" :texts="textsRolledTwo"></app-header-mini>
        <app-header-mini v-if="this.$route.params.category === 'extruded'" :img="'/static/img/products/extruded/extruded_header.jpg'" :texts="textsExtruded"></app-header-mini>
    </div>
</template>

<script>
import HeaderMini from "../shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  },
  data() {
    return {
      textsRolledOne: ["Rolled products - Foils"],
      textsRolledTwo: ["Rolled products - Sheets & Strips"],
      textsExtruded: ["Extruded products"]
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/products/Header.vue